/* eslint-disable camelcase */
const actions = {
  SET_STATE: 'menu/SET_STATE',
  GET_DATA: 'menu/GET_DATA',
}

export default actions
